// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d1661f02","453":"ed91a15d","455":"45cb49bd","879":"9bab88c6"}[chunkId] + ".chunk.js";
};